import { PlayCircle, Users } from 'lucide-react'
import { Button } from '../../../ui/new/button'
import { CollabSession } from '../../../../@types'
import toHumanReadableTimeDiff from '../../../../utils/human-time'

type Props = {
  sessions: Array<CollabSession>
  onStartSession: (arg: string | null) => void
  onCreateSession: () => void
  onDeleteSession: (arg: string | null) => void
}

const CollabPickSession = ({ sessions, onStartSession, onCreateSession, onDeleteSession }: Props) => (
  <div className="text-center">
    <Users size="200" className=" mx-auto text-primary" />
    <h3 className="text-xl font-bold leading-6 text-primary">Colaboração ao vivo...</h3>

    <p className="mt-6 text-sm text-gray-600">
      <span className="font-bold block text-gray-800">
        Podes convidar amigos para as tuas opções para colaborar contigo.
      </span>
      Não te preocupes, todas as tuas opções continuam a guardar localmente no teu dispositivo.
    </p>

    <div className="flex justify-center mt-6 space-x-4 ">
      <Button className="bg-primary hover:bg-primary/90 text-white" onClick={onCreateSession}>
        <PlayCircle size="18" />
        Iniciar nova sessão
      </Button>
    </div>

    <div className="mt-6 text-center">
      <h4 className="text-md font-bold ">Sessões anteriores</h4>
      <p className="text-sm text-gray-600">
        As sessões têm um tempo de vida, pelo que se não quiseres perder as tuas opções, terás de guardar para o teu
        dispositivo localmente.
      </p>
      <ul className="mt-4 flex flex-col sm:grid sm:grid-cols-1 sm:gap-y-4">
        {sessions.map((session) => (
          <li
            key={session.id}
            className="sm:grid sm:grid-cols-7 flex flex-col sm:mt-0  mt-6 items-center text-sm text-gray-800 gap-4"
          >
            <span className="col-span-2 truncate whitespace-nowrap font-bold">{session.name}</span>
            <span className="col-span-2 text-gray-600 truncate whitespace-nowrap">
              editado {toHumanReadableTimeDiff(session.lastEdited)}
            </span>
            <span className="col-span-2 text-gray-600 truncate whitespace-nowrap">
              expira {toHumanReadableTimeDiff(session.expirationTime)}
            </span>
            <div className="col-span-1 flex justify-end space-x-4">
              <a href="#" className="text-primary hover:underline" onClick={() => onStartSession(session.id)}>
                Entrar
              </a>
              <button className="text-primary hover:text-red-800" onClick={() => onDeleteSession(session.id)}>
                &times;
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  </div>
)

export default CollabPickSession
